namespace RioERP.Enquiry {
    export interface EnquiryFollowupRow {
        Id?: number;
        EnquiryId?: number;
        Note?: string;
        FollowedBy?: number;
        FollowUpDate?: string;
        FollowUpMode?: Web.Enums.FollowUpMode;
        UserUsername?: string;
        EnquiryEnquiryName?: string;
        EnquiryCustomerId?: number;
        EnquiryEnquiryDate?: string;
        EnquiryEStatus?: number;
        EnquiryEmailId1?: string;
        EnquiryEmailId2?: string;
        EnquiryMobile1?: string;
        EnquiryMobile2?: string;
        EnquiryAddress1?: string;
        EnquiryAddress2?: string;
        EnquiryCity?: string;
        EnquiryStateId?: number;
        EnquiryPincode?: number;
        EnquiryCountry?: string;
        EnquiryFollowupDate?: string;
        EnquiryIsActive?: boolean;
        EnquiryInsertUserId?: number;
        EnquiryInsertDate?: string;
        EnquiryUpdateUserId?: number;
        EnquiryUpdateDate?: string;
        EnquiryHandledBy?: number;
        EnquiryEEnquiryMode?: number;
    }

    export namespace EnquiryFollowupRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Note';
        export const localTextPrefix = 'Enquiry.EnquiryFollowup';
        export const deletePermission = 'Enquiry:EnquiryManagement:Modify';
        export const insertPermission = 'Enquiry:EnquiryManagement:Modify';
        export const readPermission = 'Enquiry:EnquiryManagement:View';
        export const updatePermission = 'Enquiry:EnquiryManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            EnquiryId = "EnquiryId",
            Note = "Note",
            FollowedBy = "FollowedBy",
            FollowUpDate = "FollowUpDate",
            FollowUpMode = "FollowUpMode",
            UserUsername = "UserUsername",
            EnquiryEnquiryName = "EnquiryEnquiryName",
            EnquiryCustomerId = "EnquiryCustomerId",
            EnquiryEnquiryDate = "EnquiryEnquiryDate",
            EnquiryEStatus = "EnquiryEStatus",
            EnquiryEmailId1 = "EnquiryEmailId1",
            EnquiryEmailId2 = "EnquiryEmailId2",
            EnquiryMobile1 = "EnquiryMobile1",
            EnquiryMobile2 = "EnquiryMobile2",
            EnquiryAddress1 = "EnquiryAddress1",
            EnquiryAddress2 = "EnquiryAddress2",
            EnquiryCity = "EnquiryCity",
            EnquiryStateId = "EnquiryStateId",
            EnquiryPincode = "EnquiryPincode",
            EnquiryCountry = "EnquiryCountry",
            EnquiryFollowupDate = "EnquiryFollowupDate",
            EnquiryIsActive = "EnquiryIsActive",
            EnquiryInsertUserId = "EnquiryInsertUserId",
            EnquiryInsertDate = "EnquiryInsertDate",
            EnquiryUpdateUserId = "EnquiryUpdateUserId",
            EnquiryUpdateDate = "EnquiryUpdateDate",
            EnquiryHandledBy = "EnquiryHandledBy",
            EnquiryEEnquiryMode = "EnquiryEEnquiryMode"
        }
    }
}
